import { render, staticRenderFns } from "./Stoper.vue?vue&type=template&id=1857a058&scoped=true&"
import script from "./Stoper.vue?vue&type=script&lang=js&"
export * from "./Stoper.vue?vue&type=script&lang=js&"
import style0 from "./Stoper.vue?vue&type=style&index=0&id=1857a058&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1857a058",
  null
  
)

export default component.exports